function stubString() {
    return '';
}

export { stubString };
